import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import axios from 'axios';
import VueAxios from 'vue-axios';
import { clickOutside } from './directives';
import VueWaypoint from 'vue-waypoint';

Vue.config.productionTip = false

Vue.use(VueAxios, axios);
Vue.use(VueWaypoint);

Vue.filter('replaceSpacesWithHyphens', function (value) {
  return (value) ?
    value.replace(/\s/g, '-'):
    '';
});

Vue.filter('lowercase', function (value) {
  return (value) ?
    value.toString().toLowerCase() :
    '';
});

Vue.filter('date', function (value) {
  let date = new Date(value);
  let year = date.getFullYear();
  let day = date.getDate();
  let months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];
  let index = date.getMonth();
  let month = months[index];
  return month + ' ' + day + ', ' + year
});

Vue.filter('strip', function (value) {
  return (value) ?
    value.replace(/(<([^>]+)>)/ig, '') :
    '';
});

Vue.directive('click-outside', clickOutside);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
